document.addEventListener("DOMContentLoaded", () => {
  const variantButtons = document.querySelectorAll(".variant-button input");

  variantButtons.forEach((button) => {
    button.addEventListener("change", (event) => {
      // Remove active class from all buttons
      document.querySelectorAll(".variant-button").forEach((btn) => {
        btn.classList.remove("active");
      });

      // Add active class to the selected button
      event.target.parentElement.classList.add("active");
    });
  });

  const quantitySelectors = document.querySelectorAll(".quantity-selector");

  quantitySelectors.forEach((selector) => {
    const minusButton = selector.querySelector(".qty-minus");
    const plusButton = selector.querySelector(".qty-plus");
    const quantityInput = selector.querySelector(".qty-input");

    // Decrease quantity
    minusButton.addEventListener("click", function () {
      let currentValue = parseInt(quantityInput.value) || 1;
      const minValue = parseInt(quantityInput.min) || 1;
      if (currentValue > minValue) {
        quantityInput.value = currentValue - 1;
      }
    });

    // Increase quantity
    plusButton.addEventListener("click", function () {
      let currentValue = parseInt(quantityInput.value) || 1;
      const maxValue = parseInt(quantityInput.max) || Infinity;
      if (currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
      }
    });
  });

    const tabs = document.querySelectorAll('.tab-button');
    const panels = document.querySelectorAll('.tab-panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        // Remove active state from all tabs and panels
        tabs.forEach((t) => t.classList.remove('active'));
        panels.forEach((p) => p.classList.remove('active'));

        // Add active state to the clicked tab and corresponding panel
        tab.classList.add('active');
        document.getElementById(tab.dataset.tab).classList.add('active');
      });
    });
});


